module.exports = __webpack_public_path__ + "static/media/lailao_payment_icon.7f597693.png";